import Vue from 'vue';
import Router from 'vue-router';
import StepPowerPackConfigurator from './components/step2/StepPowerPackConfigurator';
import CilinderConfigurator from './components/cilinder/Configurator';
import StepPowerPack from './components/step1/StepPowerPack';
import Splash from "./components/Splash";
import HoseConfigurator from "@/components/hose/HoseConfigurator";
import MotorConfigurator from '@/components/motor/MotorConfigurator';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Splash,
    },
    {
      path: '/powerpack-motor-configurator',
      name: 'powerpack-motor-configurator',
      component: StepPowerPack,
    },
    {
      path: '/powerpack-configurator/:uid?',
      name: 'powerpack-configurator',
      component: StepPowerPackConfigurator,
    },
    {
      path: '/powerpack-generator/:uid?',
      name: 'powerpack-generator',
      component: StepPowerPackConfigurator,
    },
    {
      path: '/cilinder-configurator',
      name: 'cilinder-configurator',
      component: CilinderConfigurator,
      beforeEnter: (to, from, next) => {
        if (from.matched[0]) {
          const store = from.matched[0].instances.default.$store;
          store.commit('cilinders/clearCylinders');
        }
        next();
      }
    },
    {
      path: '/slang-configurator/:uid?',
      name: 'slang-configurator',
      component: HoseConfigurator,
    },
    {
      path: '/motor-configurator/:uid?',
      name: 'motor-configurator',
      component: MotorConfigurator,
    },
  ],
});

router.beforeEach(async (to, from, next) => {
  if (window.location.href.includes('#')) {
    next(window.location.href.split('#')[0]);
  }

  next()
})
export default router
